@if (items().length > 0) {
  <button
    id="page-header-help-button"
    type="button"
    class="help-button inline-flex items-center gap-1.5 rounded-full px-3 py-1.5"
    [matMenuTriggerFor]="helpMenu"
    [attr.aria-label]="'onboarding.help.button_label' | translate"
    (menuOpened)="onOpened()"
  >
    <mat-icon aria-hidden="true">help_outline</mat-icon>
    <span class="hidden sm:inline">{{ 'onboarding.help.button' | translate }}</span>
  </button>

  <mat-menu #helpMenu="matMenu" xPosition="before" class="onboarding-help-menu">
    <p class="help-menu-title px-4 pb-1 pt-2">{{ 'onboarding.help.menu_title' | translate }}</p>
    @for (item of items(); track item.key) {
      <button [id]="'page-header-help-' + item.key" mat-menu-item type="button" (click)="start(item)">
        <mat-icon aria-hidden="true">play_lesson</mat-icon>
        <span>{{ item.title }}</span>
        <span class="help-menu-minutes">· {{ 'onboarding.catalog.minutes' | translate: { minutes: item.minutes } }}</span>
      </button>
    }
  </mat-menu>
}
